'use client'

import type { IQueryInfo, Permission } from 'accesscontrol'
import { useContext } from 'react'
import { UserContext } from '../auth'
import { accessControl } from './control'
import { normalizeRole } from './normalizeRole'

export const usePermission = (payload: Omit<IQueryInfo, 'role'>): Permission => {
  const user = useContext(UserContext)

  return accessControl.permission({
    role: normalizeRole(user?.role),
    ...payload,
  })
}
